import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth relies solely on the httpOnly, Secure, SameSite=None session cookie set by
// the backend. No tokens are persisted in localStorage (avoids XSS token theft).
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});
